export default __webpack_public_path__ + "static/media/Control_Electrical_Building.12132431.jpg";